import { useMemo } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { prettyFloatMoney } from '@/helpers/utils';
import { safeDecimal } from '@scramble/utils';
import s from './index.module.scss';

export const FundraisingSummary = ({
  newFunds,
  refinances = [],
  children
}) => {
  const { t } = useTranslation();

  const total = useMemo(() => {
    const funds = safeDecimal(newFunds);
    const refinancesAmount = safeDecimal(refinances.reduce((sum, item) => {
      const amount = safeDecimal(item.amount);
      const current = safeDecimal(sum);
      sum = amount.add(current).toNumber();
      return sum;
    }, 0));
    return funds.add(refinancesAmount).toNumber();
  }, [newFunds, refinances]);

  return (
    <div className={s.wrapper}>
      {children || (
        <div className={s.header}>
          <div
            className="f-article-accent"
            style={{ color: 'var(--Black-600-Semi-Dark, #17232D)' }}
          >
            {t('fundraising:fr_status.fundraising_goal')}
          </div>
          <div className="f-small-regular" style={{ color: 'var(--Grey-900-Deep, #52626F)' }}>
            {t('fundraising:fr_status.your_funding_target')}
          </div>
        </div>
      )}

      <div className={s.statistics}>
        {!!newFunds && (
          <div className={s.row}>
            <div className="f-small-accent">{t('fundraising:fr_status.new_funds')}</div>
            <div className="f-small-regular">{prettyFloatMoney(newFunds)}</div>
          </div>
        )}

        {refinances?.map(refinance => (
          <div key={refinance.name} className={s.row}>
            <div className="f-small-accent">
              {t('fundraising:fr_status.refinance', { name: refinance.name })}
            </div>
            <div className="f-small-regular">{prettyFloatMoney(refinance.amount)}</div>
          </div>
        ))}

        <div className={classnames(s.row, s.total, 'f-body')}>
          <div className="f-small-accent">{t('fundraising:fr_status.total_fundraising_goal')}</div>
          <div className="f-small-accent">{prettyFloatMoney(total)}</div>
        </div>
      </div>
    </div>
  );
};
